import { render, staticRenderFns } from "./PublishingStatementsList.vue?vue&type=template&id=c2a0c122"
import script from "./PublishingStatementsList.vue?vue&type=script&lang=js"
export * from "./PublishingStatementsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports